import React, { useContext } from 'react';
import { CheckoutContext } from '../../../../Checkout.context';
import './AuthenticatedUserAccordion.css';
var defaultProps = {
  reviewingOrder: false
};

// eslint-disable-next-line no-unused-vars
export default function AuthenticatedUserAccordion(_ref) {
  var onReviewOrder = _ref.onReviewOrder,
    reviewingOrder = _ref.reviewingOrder;
  // eslint-disable-next-line no-unused-vars
  var _useContext = useContext(CheckoutContext),
    checkout = _useContext.checkout;

  // TODO implement this component
  return /*#__PURE__*/React.createElement("div", null, "AuthenticatedUserAccordion");
}
AuthenticatedUserAccordion.defaultProps = defaultProps;